import $ from 'jquery';
import { fetchJson } from 'utils/fetch';

export default function bind(customerId, caseId, siteId) {
  const showModal = () => {
    $('.modal.intervention.create')
      .modal({
        autofocus: false,
        closable: false,
      })
      .modal({
        onVisible: () => handleForm(customerId, caseId, siteId),
      })
      .modal('show');
  };

  $('.button.intervention.create').on('click', showModal);
}

function handleForm(customerId, caseId, siteId) {
  $('.ui.form.interventionCreation').form({
    on: 'blur',
    fields: {
      siteId: {
        identifier: 'siteId',
        rules: [
          {
            type: 'empty',
            prompt: 'Un site doit être selectionné',
          },
        ],
      },
      caseId: {
        identifier: 'caseId',
        rules: [
          {
            type: 'empty',
            prompt: 'Un chantier doit être selectionné',
          },
        ],
      },
    },
  });

  const caseDropdownClass = '.selection.case.dropdown';
  const siteDropdownClass = '.selection.site.dropdown';
  const taskTypeDropdownClass = '.selection.task.dropdown';

  const caseInputName = 'caseId';
  const siteInputName = 'siteId';
  const taskTypeInputName = 'taskTypes';

  $('.ui.form.interventionCreation').on('reset', evt => {
    $('.ui.form.interventionCreation').form('reset');
    return true;
  });

  if (customerId) {
    if (siteId) {
      fetchForDropdown(
        `/pco-manager/sites/${siteId}/cases.json`,
        caseDropdownClass,
        caseInputName
      );
    } else if (caseId) {
      fetchForDropdown(
        `/pco-manager/cases/${caseId}/sites.json`,
        siteDropdownClass,
        siteInputName
      );
    } else {
      fetchForDropdown(
        `/pco-manager/customers/${customerId}/sites.json`,
        siteDropdownClass,
        siteInputName,
        true
      );
      fetchForDropdown(
        `/pco-manager/customers/${customerId}/cases.json`,
        caseDropdownClass,
        caseInputName,
        true
      );
    }
  }

  $('.button.intervention.create').on('click', evt => {
    $('.modal.intervention.create')
      .modal({
        autofocus: false,
        closable: false,
      })
      .modal('show');
  });

  $(siteDropdownClass).on('change', () => {
    let value = $(siteDropdownClass).dropdown('get value');
    if (value) {
      fetchForDropdown(
        `/pco-manager/sites/${value}/cases.json`,
        caseDropdownClass,
        caseInputName
      );
    } else {
      fetchForDropdown(
        `/pco-manager/customers/${customerId}/cases.json`,
        caseDropdownClass,
        caseInputName,
        true
      );
    }
  });

  $(caseDropdownClass).on('change', () => {
    let value = $(caseDropdownClass).dropdown('get value');
    if (value) {
      fetchForDropdown(
        `/pco-manager/cases/${value}/sites.json`,
        siteDropdownClass,
        siteInputName
      );
      fetchForDropdown(
        `/pco-manager/cases/${value}/task-types.json`,
        taskTypeDropdownClass,
        taskTypeInputName
      );
    } else {
      fetchForDropdown(
        `/pco-manager/customers/${customerId}/sites.json`,
        siteDropdownClass,
        siteInputName,
        true
      );
      fetchForDropdown(
        `/pco-manager/settings/task-types.json`,
        taskTypeDropdownClass,
        taskTypeInputName
      );
    }
  });
}

// TODO: there must be a better way to handle the default value when 1 element is fetched
function handleSingleResult(res, menuClass, inputName) {
  const caseDropdownClass = '.selection.case.dropdown';

  $(`${menuClass} .menu`).html(
    '<div class="item" data-value="' + res[0].id + '">' + res[0].name + '</div>'
  );
  const defaultValue = $(`${menuClass} .default.text`);
  $(`${menuClass} input[name=${inputName}]`).val(res[0].id);
  defaultValue.removeClass('default');
  defaultValue.html(res[0].name);
  $(`${menuClass}`).dropdown('hide');
  if (menuClass === caseDropdownClass) {
    $(caseDropdownClass).change();
  }
}

function fillDropdownMenu(res, menuClass) {
  $(`${menuClass} .menu`).html(
    res.map(item => {
      return (
        '<div class="item" data-value="' + item.id + '">' + item.name + '</div>'
      );
    })
  );
  $(`${menuClass}`).dropdown('hide');
}

function fetchForDropdown(url, menuClass, inputName, clean = false) {
  fetchJson(url).then(results => {
    if (!clean && results.length === 1) {
      handleSingleResult(results, menuClass, inputName);
      return;
    }
    fillDropdownMenu(results, menuClass);
  });
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/creation/index.js